import { loginApi, SSOloginApi } from "helpers/API/AuthApi"
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  loginSuccess,
  socialLoginSuccess,
  togglePageLoader,
} from "store/actions"
import toast from "toastr"
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  LoginAccessSettingSuccess,
  LoginAccessUserDetails,
  apiError,
  loginUserSuccess,
  logoutUserSuccess,
  redirect_loginError,
  redirect_loginSuccess,
  userpasswordchangeError,
  userpasswordchangeSuccess,
} from "./actions"
// Login Redux States
import {
  LOGIN_USER,
  LOGOUT_USER,
  SOCIAL_LOGIN,
  COMPANY_SETTING,
  ACCESS_SETTING,
  USER_DETAILS,
  CHANGE_USER_PASSWORD,
  REDIRECT_LOGIN,
} from "./actionTypes"
import { changePassword, redirtect_api } from "helpers/backend_helper"

const fireBaseBackend = getFirebaseBackend()

function* loginUserviaapi({ payload: { data, history } }) {
  if (process.env.NODE_ENV === 'development') {
    console.log("🚀 Login saga called with data:", data)
  }
  localStorage.removeItem("authUser")
  try {
    yield put(togglePageLoader(true))
    if (process.env.NODE_ENV === 'development') {
      console.log("🚀 Calling loginApi with data:", data)
    }
    const response = yield call(loginApi, data)
    if (response.status === "Success") {
      localStorage.setItem("authUser", JSON.stringify(response))
      localStorage.setItem("authUsers", JSON.stringify(data))
      yield put(loginSuccess(response))
      yield put(togglePageLoader(false))
      const CategoryUser = response?.data?.accessgroupname === "CategoryUser"
      if (CategoryUser == true) {
        history.push("/client/viewhours")
      } else {
        history.push("/verifyscreen")
      }
    } else {
      yield put(togglePageLoader(false))
      yield put(apiError(response))
    }
  } catch (error) {
    yield put(togglePageLoader(false))
    localStorage.removeItem("authUser")
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("authUsers")
    localStorage.removeItem("token")
    localStorage.removeItem("userid")
    localStorage.removeItem("bookmark")
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  localStorage.removeItem("authUser")
  try {
    yield put(togglePageLoader(true))
    const response = yield call(SSOloginApi, data)
    if (response.status === "Success") {
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(socialLoginSuccess(response))
      yield put(togglePageLoader(false))
      history.push("/verifyscreen")
    } else {
      yield put(togglePageLoader(false))
      yield put(apiError(response.error))
    }
  } catch (error) {
    yield put(togglePageLoader(false))
    localStorage.removeItem("authUser")
    yield put(apiError(error))
  }
}

function* changepassword({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(changePassword, data)
    if (response.statusCode === 200) {
      yield put(userpasswordchangeSuccess(response))
      yield put(togglePageLoader(false))
      toast.success(response.message)
      callback("SUCCESS")
    } else {
      yield put(togglePageLoader(false))
      toast.error(response.message)
      yield put(userpasswordchangeError(response.error))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(togglePageLoader(false))
    yield put(userpasswordchangeError(error))
    toast.error(error?.response ? error.response.message : error)
    callback("FAILURE")
  }
}
function* loginuserdata({ payload: { data } }) {
  yield put(loginUserSuccess(data))
}

function* loginaccessdata({ payload: { data } }) {
  yield put(LoginAccessSettingSuccess(data))
}

function* loginusersdata({ payload: { data } }) {
  yield put(LoginAccessUserDetails(data))
}

// aplication once click redirect login to dashboard or verify screen
function* redirectLogin({ payload: { data, history } }) {
  localStorage.removeItem("authUser")
  localStorage.removeItem("authUsers")
  const searchParams = new URLSearchParams(window.location.search)
  const RedirectionUrl = searchParams.get("redirectUrl")
  const userid = searchParams.get("userId")
  const date = searchParams.get("date")
  const subcategoryId = searchParams.get("subcategory")
  const clientId = searchParams.get("clientId");
  const accountId = searchParams.get("accountId")
  try {
    yield put(togglePageLoader(true))
    const response = yield call(redirtect_api, data)
    if (response?.statusCode === 200) {
      localStorage.setItem("authUser", JSON.stringify(response))
      const suthusersss = {
        username: response?.data?.email,
        password: "",
        Platform: "web",
      }
      localStorage.setItem("authUsers", JSON.stringify(suthusersss))
      yield put(redirect_loginSuccess(response))
      yield put(togglePageLoader(false))
      if (response?.message === "Get User Data") history.push("/verifyscreen")
      else {
        console.log(RedirectionUrl, 'RedirectionUrl')
        history.push(`${RedirectionUrl}?userId=${userid}&date=${date}&subcategoryId=${subcategoryId}&accountId=${accountId}&clientId=${clientId}`)
      }
    } else {
      yield put(togglePageLoader(false))
      yield put(redirect_loginError(response.error))
    }
  } catch (error) {
    setTimeout(() => {
      toast.error(`Your token is expired.`)
    }, 3000)
    yield put(togglePageLoader(false))
    localStorage.removeItem("authUser")
    yield put(redirect_loginError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUserviaapi)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(COMPANY_SETTING, loginuserdata)
  yield takeEvery(ACCESS_SETTING, loginaccessdata)
  yield takeEvery(USER_DETAILS, loginusersdata)
  yield takeEvery(CHANGE_USER_PASSWORD, changepassword)
  yield takeEvery(REDIRECT_LOGIN, redirectLogin)
}

export default authSaga
